module.exports = __webpack_public_path__ + "img/decorate2.00c84d1c.svg";